// PaintedAreaCalculator.js

import React, { useState } from 'react';

const PaintedAreaCalculator = () => {
  const [width, setWidth] = useState('');
  const [length, setLength] = useState('');
  const [ceiling, setCeiling] = useState('');
  const [doorways, setDoorways] = useState('');
  const [doors, setDoors] = useState('');
  const [squareFootage, setSquareFootage] = useState(0);
  const [paintedArea, setPaintedArea] = useState(0);
  const [baseboardArea, setBaseboard] = useState(0);
  const [doorsPrice, setDoorPrice] = useState(0);

  const handleWidthChange = (e) => {
    setWidth(e.target.value);
  };

  const handleLengthChange = (e) => {
    setLength(e.target.value);
  };

  const handleCeilingChange = (e) => {
    setCeiling(e.target.value);
  }

  const handleDoorwayChange = (e) => {
    setDoorways(e.target.value);
  }

  const handleDoorChange = (e) => {
    setDoors(e.target.value);
  }

  const calculatePaintedArea = (e) => {
    e.preventDefault();
    const widthValue = parseFloat(width);
    const lengthValue = parseFloat(length);
    const ceilingValue = parseFloat(ceiling);
    const doorwaysValue = parseFloat(doorways);
    const doorValue = parseFloat(doors);    

    if (!isNaN(widthValue) && !isNaN(lengthValue) && !isNaN(ceilingValue)) {
      const calculatedSquareFootage = widthValue * lengthValue;
      setSquareFootage(calculatedSquareFootage);
      const calculatedPaintedArea = ((width * 2) + (length * 2)) * ceilingValue;
      setPaintedArea(calculatedPaintedArea);
      //Doorway trim, needs to be added to other trim calc
      if (!isNaN(doorwaysValue)) {
      var calculatedBaseboard = (width * 2) + (length * 2) + (doorways * 17); }
      else {
      calculatedBaseboard = (width * 2) + (length * 2); }
      setBaseboard(calculatedBaseboard);
      //Get the total price for doors
    if (!isNaN(doorValue)) {
      const CalculatedDoorPrice = (doors * 30);
      setDoorPrice(CalculatedDoorPrice);
    }
    }

  };
  return (
    <div className="space-y-2">
      <form onSubmit={ calculatePaintedArea }>
        <div>
          <label className="block mb-2" htmlFor="width"><span className="text-gray-700">Width: </span></label>
          <input
            className='
            form-input 
            block
            w-full
            mt-1
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
            '
            type="number"
            id="width"
            value={width}
            onChange={handleWidthChange}
            required
          />
        </div>
        <div>
          <label className="block mb-2" htmlFor="length">Length: </label>
          <input
            className='
            form-input 
            block
            w-full
            mt-1
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
            '
            type="number"
            id="length"
            value={length}
            onChange={handleLengthChange}
            required
          />
        </div>
        <div>
          <label className="block mb-2" htmlFor="ceiling">Ceiling Height: </label>
          <input
            className='
            form-input 
            block
            w-full
            mt-1
            mb-2
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
            '
            type="number"
            id="ceiling"
            value={ceiling}
            onChange={handleCeilingChange}
            required
          />
        </div>
        <div>
          <label className="block mb-2" htmlFor="doorways">Doorways: </label>
          <input
            className='
            form-input 
            block
            w-full
            mt-1
            mb-2
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
            '
            type="number"
            id="doorways"
            value={doorways}
            onChange={handleDoorwayChange}
          />
        </div>
        <div>
          <label className="block mb-2" htmlFor="doors">Doors: </label>
          <input
            className='
            form-input 
            block
            w-full
            mt-1
            mb-2
            border-gray-300
            rounded-md
            shadow-sm
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
            '
            type="number"
            id="doors"
            value={doors}
            onChange={handleDoorChange}
          />
        </div>
        <button className="
            h-10
            px-5
            text-indigo-100
            bg-indigo-700
            rounded-lg
            transition-colors
            duration-150
            focus:shadow-outline
            hover:bg-indigo-800
            " 
            type="submit">Calculate</button>
      </form>
      <div className='py-2'>
      <p className='mb-4 text-xl font-medium'>Total Painted Area: {paintedArea} sq ft.</p>
      <p className='mb-4 text-xl font-medium'>Ceiling: {squareFootage} sq ft.</p>
      <p className='mb-4 text-xl font-medium'>Total Trim: {baseboardArea} linear ft.</p>
      <p className='mb-4 text-xl font-medium'>Door Price: ${doorsPrice} </p>
      </div>
    </div>
  );
};

export default PaintedAreaCalculator;
